import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../slices/authSlice';
import Loader from '../components/Loader';

const GoogleAuthSuccessScreen = () => {
    const navigate  = useNavigate();
    const dispatch  = useDispatch();
    const { search } = useLocation();

    useEffect(() => {
        const params  = new URLSearchParams(search);
        const user = {
            _id:     params.get('_id'),
            name:    params.get('name'),
            email:   params.get('email'),
            isAdmin: params.get('isAdmin') === 'true',
        };

        if (user._id) {
            dispatch(setCredentials(user));
            navigate('/');
        } else {
            navigate('/login?error=google_failed');
        }
    }, [search, dispatch, navigate]);

    return <Loader />;
};

export default GoogleAuthSuccessScreen;